import ImageWithBasePath from "../../../../core/common/imageWithBasePath";
import { useTranslation } from "react-i18next";

export const Vision = () => {
  const { t } = useTranslation();

  const items = [
    { icon: "assets/img/icons/vision-icon-001.png", key: "vision.item1" },
    { icon: "assets/img/icons/vision-icon-002.png", key: "vision.item2" },
    { icon: "assets/img/icons/vision-icon-003.png", key: "vision.item3" },
    { icon: "assets/img/icons/vision-icon-004.png", key: "vision.item4" },
  ];

  return (
    <section className="bg-[#009fe3] py-10">
      <div className="max-w-7xl mx-auto px-4">
        <div className="bg-white shadow-xl rounded-lg p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {items.map((item, index) => (
              <div key={index} className="flex items-center gap-4">
                <div className="w-16 h-16 flex items-center justify-center border rounded-full">
                  <ImageWithBasePath src={item.icon} alt="vision" className="w-10 h-12" />
                </div>
                <p className="text-gray-700 font-medium">{t(item.key)}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Vision;
